import React, { useEffect, useState } from 'react';
import Navbar from '../../Components/Common/Navbar';
import Footer from '../../Components/Common/Footer';
import HeroSection from '../../Components/Sections/HeroSections';
import FeaturesSection from '../../Components/Sections/FeaturesSection';
import TestimonialsSection from '../../Components/Sections/TestimonialsSection';
import DemoSection from '../../Components/Sections/DemoSection';
import ProductFeaturesSection from '../../Components/Sections/ProductFeaturesSection';
import PackagesSection from '../../Components/Sections/PackagesSection';
import SupportSection from '../../Components/Sections/SupportSection';
import TeamSection from '../../Components/Sections/TeamSection';
import VisitSection from '../../Components/Sections/VisitSection';
import FAQSection from '../../Components/Sections/FAQSection';
import ReviewsSection from '../../Components/Sections/ReviewsSection';
import StickyPricingFooter from '../../Components/Sections/StickyPricingFooter';
import { useLeadData } from '../../Utils/LeadContext';
import { getImagePath, checkLPData, isFlashOfferOn, isIOSMobileDevice } from '../../Utils/Utilities';
import IOSRestrictedModal from '../../Components/Common/IOSRestrictedModal';
import { useSearchParams, useLocation } from 'react-router-dom';
import apiService from '../../Utils/APIService';
import { useBrand } from '../../Utils/BrandContext';
import { COUPONS } from '../../Constants/Packages';
import ContactSection from '../../Components/Sections/ContactSection';
import HeroSectionCompact from '../../Components/Sections/HeroSectionCompact';
import ProductFeatures from '../../Components/Sections/ProductFeatures';
import { useIsMobile } from '../../Hooks/useIsMobile';
import SupportDesktopSection from '../../Components/Sections/SupportDesktopSection';
import GoLiveSection from '../../Components/Sections/GoLiveSection';


const GERP = () => {
  const { leadData, loading } = useLeadData();
  const { brand: activeBrand } = useBrand();
  const [showIOSModal, setShowIOSModal] = useState(false);
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const currentPage = pathname.replace('/', '').toUpperCase() || 'GERP';

  const rfdAvl = false;
  const flashOfferOn = isFlashOfferOn();
  const srcParam = new URLSearchParams(window.location.search).get('src') || '';
  const isFromFdbk = srcParam === 'fdbk';
  const isMidnight = [0, 1, 23].includes(new Date().getHours());


  const brandLogo = activeBrand === 'bz' ? getImagePath("/Images/Biziverse.png") : getImagePath("/Images/QikERP.png");
  const isFromGQik = true; // Flag to indicate this is GQik page
  const isMobile = typeof window !== 'undefined' && /Mobi|Android/i.test(navigator.userAgent);

  const PIXEL_ID = "1652655355901271";
  const EVENT_NAME = "PageView";

  // --- META PIXEL INTEGRATION START ---
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", EVENT_NAME);
      return;
    }

    // Standard Meta Boilerplate (Never changes)
    const fbq = function () {
      fbq.callMethod
        ? fbq.callMethod.apply(fbq, arguments)
        : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
    window.fbq = fbq;

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // Use the variables here
    window.fbq("init", PIXEL_ID);
    window.fbq("track", EVENT_NAME);
  }, []);

  const sendSensor = (actionID, actionTxt = '', sensorTxt = '') => {
    const finalTxt = sensorTxt || actionTxt;
    const allDataRaw = localStorage.getItem('allData');
    let leadPIN = '';
    let mobile = '';
    if (allDataRaw) {
      const allData = JSON.parse(allDataRaw);
      const leadInfo = allData.info ? JSON.parse(allData.info) : [];
      mobile = allData.mobile || '';
      leadPIN = leadInfo[0]?.LeadO || '';
    }
    apiService.sendCallSensorReq(actionID, finalTxt, { leadPIN, mobile, device: isMobile ? 'M' : 'D' });
  };

  useEffect(() => {
    if (!checkLPData('GQIK', searchParams)) return;
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);
  const handleLoginClick = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      const navbarHeight = 70;
      const targetPosition = heroSection.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Focus on mobile input after scroll
      setTimeout(() => {
        const mobileInput = document.getElementById('mobile');
        if (mobileInput) {
          mobileInput.focus();
          // Add highlight effect
          const wrapper = mobileInput.parentElement;
          if (wrapper) {
            wrapper.style.borderColor = '#e88421';
            wrapper.style.boxShadow = '0 0 10px rgba(232, 132, 33, 0.5)';

            setTimeout(() => {
              wrapper.style.borderColor = '';
              wrapper.style.boxShadow = '';
            }, 2000);
          }
        }
      }, 600);
    }
  };

  const handleGetStarted = (mobileNumber) => {
    console.log('Get Started with:', mobileNumber);
    // Add your get started logic here
    // e.g., navigate to signup page: window.location.href = `/Join01.html?i=${mobileNumber}&x=Desktop_QikERP`;
  };

  const handleLogin = (mobileNumber) => {
    console.log('Login with:', mobileNumber);
    // Add your login logic here
    // e.g., show login modal or make API call
  };

  useEffect(() => {
    if (!checkLPData('GQIK', searchParams)) return;

    const dParam = searchParams.get('d') || '';
    const dScrollMap = { '1': 'demo', '4': 'about' };
    const scrollParam = searchParams.get('scroll') || searchParams.get('s') || dScrollMap[dParam] || '';

    if (scrollParam !== 'pricing') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }

    if (scrollParam === 'pricing') {
      setTimeout(() => {
        const packagesSection = document.getElementById('simplePricing');
        if (packagesSection) {
          window.scrollTo({
            top: packagesSection.offsetTop - 60,
            behavior: 'smooth'
          });
        }
      }, 200);
    }

    if (scrollParam === 'demosection' || scrollParam === 'demo') {
      setTimeout(() => {
        const demoSection = document.getElementById('demoSection');
        if (demoSection) {
          window.scrollTo({
            top: demoSection.offsetTop - 60,
            behavior: 'smooth'
          });
        }
      }, 200);
    }
    if (scrollParam === 'about') {
      setTimeout(() => {
        const aboutSection = document.getElementById('bzvzTeam');
        if (aboutSection) {
          window.scrollTo({
            top: aboutSection.offsetTop - 60,
            behavior: 'smooth'
          });
        }
      }, 200);
    }
  }, [searchParams]);

  const handleScrollToPricing = () => {
    const packagesSection = document.getElementById('simplePricing');
    if (packagesSection) {
      window.scrollTo({
        top: packagesSection.offsetTop - 70,
        behavior: 'smooth'
      });
    }
  };

  const handleBuyNow = (editionId = 37) => {
    if (isIOSMobileDevice()) {
      setShowIOSModal(true);
      return;
    }
    const finalEdnId = editionId ?? 37;
    const allDataRaw = localStorage.getItem('allData');

    if (allDataRaw) {
      const allData = JSON.parse(allDataRaw);
      const leadInfo = allData.info ? JSON.parse(allData.info) : [];

      localStorage.setItem("selEdn", finalEdnId);
      localStorage.setItem("selPrd", "YY");
      const defaultCpn = Object.values(COUPONS).find(c => c.editionID === finalEdnId && c.default === true);
      if (defaultCpn) { localStorage.setItem("cpn", defaultCpn.code); }
      else { localStorage.removeItem("cpn"); }
      localStorage.setItem("guidePG", window.location.pathname.substring(1));

      const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
      localStorage.setItem('cio', JSON.stringify(cioData));
      const currentParams = window.location.search;
      window.location.href = "/Html/External/BZPay.html" + currentParams;
    } else {
      handleScrollToPricing();
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=${EVENT_NAME}&noscript=1`}
        />
      </noscript>

      <Navbar
        logo={brandLogo}
        onLoginClick={handleLoginClick}
        isFromGQik={isFromGQik}
        onBuyNowClick={() => {
          handleScrollToPricing();
          sendSensor(105, 'Buy Now Clicked');
        }}
      />

      <main>
        {/* Hero Section */}
        {/* <HeroSection
          onGetStarted={handleGetStarted}
          onLogin={handleLogin}
          isFromGQik={isFromGQik}
          onBuyNow={() => { sendSensor(105, 'Buy Now Clicked'); }}
          logo={brandLogo}
          rfdAvl={rfdAvl}
          flashOfferOn={flashOfferOn}
          isMidnight={isMidnight}
        /> */}
        <HeroSectionCompact
          onGetStarted={handleLogin}
          onLogin={handleLogin}
          onPricing={handleScrollToPricing}
          pageName={currentPage}
        />

        {/* Features Section */}
        {useIsMobile() && <FeaturesSection
          onBuyNow={handleScrollToPricing}
          pricing={{ silver: 2999, gold: 4999 }}
          rfdAvl={rfdAvl}
          onBuyNowClick={() => sendSensor(105, 'Buy Now Clicked')}
          flashOfferOn={flashOfferOn}
          forceOfferKey={isFromFdbk ? 'FDBK_CLRNC' : null}
          pageName={currentPage}

        />}

        {/* Demo Section */}
        {useIsMobile() && <DemoSection onDemoView={() => sendSensor(4, 'Reached Demo')} onDemoOpen={() => sendSensor(4, 'Demo')} onDemoScreens={() => sendSensor(7, 'DemoScreens')} />}

        <ProductFeatures onBuyNow={handleScrollToPricing} onFeatureClick={(featureName) => sendSensor(104, featureName)} />

        {!useIsMobile() && <SupportDesktopSection />}



        {/* Testimonials Section */}
        {/* <TestimonialsSection /> */}


        {/* Product Features Section */}
        {/* <ProductFeaturesSection onBuyNow={handleScrollToPricing} onFeatureClick={(featureName) => sendSensor(104, featureName)} /> */}

        {/* Packages/Pricing Section */}
        <PackagesSection
          onBuyNow={handleBuyNow}
          pageName={currentPage}
          showCoupons={true}
          forceOfferKey={isFromFdbk ? 'FDBK_CLRNC' : null}
          onCouponView={(editionName) => sendSensor(109, `View Coupons (${editionName})`)}
          onPackageClick={(pkgId) => sendSensor(pkgId)}
          onPackageView={() => sendSensor(4, 'Package View')}
          onGetOffer={() => sendSensor(4, 'Get Offer Clicked')}
        />

        <GoLiveSection />

        <TestimonialsSection brandLogo={brandLogo} />

        {/* Support Section */}
        <SupportSection />

        {/* Team/About Section */}
        <TeamSection onTeamView={() => sendSensor(11, 'Team')} />

        {/* Visit Section */}
        <VisitSection />

        {/* FAQ Section */}
        <FAQSection
          onFAQToggle={(question) => sendSensor(106, `Guide-FAQ (${question})`)}
          onBuyNow={handleScrollToPricing}
        />

        <ContactSection className="" isFromLP={true} />
      </main>

      <Footer />
      <StickyPricingFooter
        onBuyNow={handleBuyNow}
        onGetOffer={() => sendSensor(4, 'Flash Footer Clicked')}
        forceOfferKey={isFromFdbk ? 'FDBK_CLRNC' : null}
        pageName={currentPage}
      />
      <IOSRestrictedModal isOpen={showIOSModal} onClose={() => setShowIOSModal(false)} />
    </div>
  );
};

export default GERP;